var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.418,
    height: 9.598,
    viewBox: "0 0 16.418 9.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stats-down",
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M16.5,17.184,10.025,10.7l-3.41,3.41L1.5,9",
    transform: "translate(-1.5 -9)",
    fill: "none",
    stroke: "#ff6a6a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M25.5,13.092h4.092V9",
    transform: "translate(-14.588 -4.908)",
    fill: "none",
    stroke: "#ff6a6a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsDown);
export default __webpack_public_path__ + "static/media/stats-down.8036292bb5f1be9218939223a9401785.svg";
export { ForwardRef as ReactComponent };